'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatLink = undefined;

var _urlParse = require('url-parse');

var _urlParse2 = _interopRequireDefault(_urlParse);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

var formatLink = exports.formatLink = function formatLink(link) {
  var parsedUrl = (0, _urlParse2['default'])(link);

  if (parsedUrl.protocol === 'tel:' || parsedUrl.protocol === 'mailto:') {
    return link;
  }

  if (!/^(?:f|ht)tps?\:\/\//.test(link)) {
    return 'http://' + link;
  }

  return link;
};

exports['default'] = formatLink;